import { get } from 'lodash';
import { LICENSE_TYPES } from '../Constants';

export const rankAccessor = (item) => get(item, 'track.rank', get(item, 'rank', 0));

export const completeAccessor =
    (dictionary = {}) =>
    (asset) => {
        const item = get(dictionary, asset._id, asset);
        const isComplete = get(item, 'isComplete', false);
        const completeness = get(item, 'completeness', 0) || 0;

        if (isComplete || completeness >= 100) {
            return 3;
        }
        if (completeness > 0 && completeness < 100) {
            return 1;
        }
        return 2;
    };

export const statusAccessor = (item) => {
    if (item.status === 'STARTED') {
        return 3;
    }
    if (item.status === 'IN_PROGRESS') {
        return 2;
    }
    if (item.status === 'ASSIGNED' || (item.recommendationInfo && item.recommendationInfo.code === 'ASSIGNED')) {
        return 1;
    }
    if (item.status === 'COMPLETED') {
        return 5;
    }
    return 4;
};

export const orderAccessor = (item) => {
    return item.orderId;
}

export const languageAccessor = (language) => (asset) => {
    if (get(asset, 'languageCode', 'en-us') === language) {
        return 1;
    }
    return 0;
};

export const subscriptionTypeAccessor = (item) =>
    (get(item, 'subscriptionType', '') || '').toLocaleUpperCase() === LICENSE_TYPES.EXCLUSIVE_COMPANY_LICENSE_UPPER;

export const givenBehaviorAccessor = (behaviorId) => (item) => {
    const doesItemContainBehaviorId = get(item, 'behaviors', []).includes(behaviorId);

    return doesItemContainBehaviorId ? 1 : 0;
};

export const isCustomAccessor = (item) => {
    if (item.isCustomCollection) {
        return 1;
    }
    return 0;
};

export const propertyLengthAccessor = (property) => (object) => object[property];

export const lockedItemAccessor = (item) => (item.isLocked ? 1 : 0);

